module.exports = __webpack_public_path__ + "assets/img/34_717.62ea9d8e.jpg";